export default function PermissionPopup() {
  return (
    <div className="inset-0  bg-opacity-50 flex items-center justify-center z-50 h-full">
      <div className="bg-[#dbeafe] rounded-lg shadow-lg w-full max-w-[600px] p-10 relative text-center">
        <h2 className="text-xl font-semibold mb-4">Access Denied</h2>
        <p className="mb-6">You do not have permission to view this page.</p>
      </div>
    </div>
  );
}
